import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  T_StockSliceState,
  T_StockDashboardDetails,
} from "./Stockc&Securities_Types";

const initialState: T_StockSliceState = {
  stockDashboardDetails: [],
  CustomerData: {},
  secondaryStockDashboardDetails: [],
  serviceMenuDetails: [],
  maskDetailsPageValues: false,
};

export const StocksSlice = createSlice({
  name: "StocksSlice",
  initialState,
  reducers: {
    setStocksDashboardDetails: (
      state,
      action: PayloadAction<T_StockDashboardDetails[]>,
    ) => {
      return {
        ...state,
        stockDashboardDetails: action.payload,
      };
    },
    setSecondaryStockDashboardDetails: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        secondaryStockDashboardDetails: action.payload,
      };
    },
    setServiceMenuDetails: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        serviceMenuDetails: action.payload,
      };
    },
    setMaskStocksDetailsPageValues: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        maskDetailsPageValues: action.payload,
      };
    },
  },
});

export const StocksSliceReducer = StocksSlice.reducer;
export const StocksSliceKey = StocksSlice.reducerPath;

export const {
  setStocksDashboardDetails,
  setSecondaryStockDashboardDetails,
  setServiceMenuDetails,
  setMaskStocksDetailsPageValues,
} = StocksSlice.actions;
